// extracted by mini-css-extract-plugin
export var next = "Pagination-module--next--6f91d";
export var paginate = "Pagination-module--paginate--4fb31";
export var previous = "Pagination-module--previous--93dec";